import { MATCHING } from '@common/constants';
import { SectionTypes } from '@common/enums/section-type-enum';
import { SaveAction } from '@common/models/save-action.model';

import { Section } from './section-model';

export enum RetailerDocumentType {
    PRIVACY_POLICY = 'Privacy Policy',
    TEMPLATE_CHECKLIST = 'Template Checklist',
    INSTALL_CHECKLIST = 'Installation Checklist',
    CUSTOMER_EXPECTATIONS = 'Customer Expectation Agreement',
}

export interface RetailerDocument {
    type: RetailerDocumentType;
    url: string | null;
}

/**
 * these are the only user options we expect
 */
export enum UserOption {
    PrintInternal = 'printInternalDocument', // the user can print the internal document after saving
    DiscountOverride = 'discountOverride', // the user can use an otherwise hidden discount override feature
    ShowUnitPrice = 'showUnitPrice', // show the user an additional column with unit price
}

export interface RetailerSettings {
    companyCode: string;
    materialPriceIndication: { averagePrice: boolean; minMaxPrice: boolean };
    showNavigationMenu: boolean;
    showPriceDetails: { showDetails: boolean; collapsable: boolean };
    showStores: boolean;
    tearOutMaterial: boolean;
    uploadFiles: boolean;
    documents: RetailerDocument[];
    saveActions: SaveAction[] | null;
    expirationDays: number;
    isOnlineRetailer: boolean;
    confirmSmallProjectOverride: boolean;
    enableMatching: MATCHING; //0=disable, 1=Ken, 2=Ricardo
    userOptions: UserOption[];
    googleMapApiKey?: string;
    googleMapApiMapId?: string;
}

export type ApplianceSectionType =
    // eslint-disable-next-line camelcase
    | SectionTypes.cooking_appliance
    | SectionTypes.sink
    | SectionTypes.faucet
    | SectionTypes.dishwasher
    | SectionTypes.refrigerator;

export type ApplianceUrls = {
    [key in ApplianceSectionType]: string;
};

interface SubSectionOption {
    browse: boolean;
    customerSupplied: boolean;
    none: boolean;
}

type SubSectionOptions = {
    [key in ApplianceSectionType]: SubSectionOption;
};

export interface RetailerFileSettings {
    bottomSections: Section[];
    showPurchaseButton: boolean;
    showSaveButton: boolean;
    showVisualizer?: boolean;
    inStoreApplianceURLs: ApplianceUrls;
    subsectionOptions: SubSectionOptions;
    showSendEmailOption?: boolean; // NOTE: This is an optional value, see useRetailerSettings
}
